import { useLayoutEffect } from "react";
import "./App.css";
import { checkLoggedIn } from "./routing";
import { HashRouter as Router, Routes, Route } from "react-router-dom"; // Change BrowserRouter to HashRouter
import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";
import { ManagementRoutes } from "./mng/routes/ManagementRoutes";
import IntroPage from "./pages/IntroPage";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { colors } from "./common/colors";
import MyFarm from "./pages/MyFarm";
import DashboardPage from "./pages/DashboardPage";
import CreatePost from "./pages/CreatePost";
import Header from "./components/Header";
import Unauthorized from "./unauthorized";
import VotingSeeMorePage from "./pages/VotingSeeMorePage";
import { AuthProvider } from "react-auth-verification-context";
import { Translator, Config } from "react-translator-component";
import { useSelector } from "react-redux";
import { language_config } from "./common/constants/language_config";
import PageViewTracker from "./components/PageViewTracker";
import PostReport from "./components/PostReport";
import CategoryListPage from "./pages/CategoryListPage";
import setAuthorizationToken from "./services/axios-util/set-authorization-token";
import SuggestionBox from "./pages/SuggestionBox";
import FacilitatorList from "./pages/FacilitatorList";
import PostHistory from "./pages/MyFarmsPages/PostHistory";
import SearchScreen from "./pages/phase2/SearchScreen";
import EveryOnesPostHistory from "./pages/MyFarmsPages/EveryOnesPostHistory";
import CommentHistory from "./pages/MyFarmsPages/CommentHistory";
import CreateGroupStep1 from "./pages/GreenCity/CreateGroupStep1";
import CreateGroupStep2 from "./pages/GreenCity/CreateGroupStep2";
import GroupInfoReview from "./pages/GreenCity/GroupInfoReview";
import Disclosure from "./pages/GreenCity/Disclosure";
import CreateGroupStepPII from "./pages/GreenCity/CreateGroupStepPII";
import GroupOwnerSettingPage from "./pages/GreenCity/GroupOwnerSettingPage";
import ViewGroupPost from "./pages/GreenCity/ViewGroupPost";
import GroupEventSettingPage from "./pages/GreenCity/GroupEventSettingPage";
import GroupMembers from "./pages/GreenCity/JoinProcess/GroupMembers";
import MemberList from "./pages/GreenCity/MemberList";
import ApprovedMemberList from "./pages/ApprovedMemberList";
import CalenderEvents from "./pages/GreenCity/CalenderEvents";
import UserChat from "./pages/GreenCity/chats/UserChat";
import GroupPayment from "./pages/GreenCity/JoinProcess/GroupPayment";
import EventApplicationPayment from "./pages/GreenCity/EventApplicationPayment";
import GroupChatList from "./pages/GreenCity/chats/GroupChatList";
import GroupEventsCalendar from "./pages/GreenCity/GroupEventsCalendar";
import UserEventCancellation from "./components/Phase2/UserEventCancellation";
import RefundEventFee from "./components/Phase2/RefundEventFee";
import GroupCancelMembership from "./pages/GreenCity/GroupCancelMembership"
import GroupCloseDetails from "./pages/GreenCity/GroupCloseDetails"
import GroupRoles from "./pages/GreenCity/JoinProcess/GroupRoles";
import CancelRequestsPage from "./pages/CancelRequestsPage";
import EventUsers from "./pages/GreenCity/EventUsers";
import InvitionLinkCreations from "./pages/GreenCity/JoinProcess/Invite/InvitionLinkCreations";
import GroupInvite from "./pages/GreenCity/JoinProcess/Invite/GroupInvite";
import EventPostDetails from "./pages/GreenCity/EventPostDetails";
import UserEventPaymentDetail from "./components/Phase2/UserEventPaymentDetail";
import EventCancelDetails from "./pages/EventCancelDetails";
import MemberPaymentStatus from "./pages/GreenCity/MemberPaymentStatus";
import UserChatList from "./pages/GreenCity/chats/UserChatList";
import ScanStoreQR from "./pages/GreenCity/PaytoStore/ScanStoreQR";
import GroupUserPayment from "./pages/GreenCity/GrouptoUserPay/GroupUserPayment";
import PaymentReimbursement from "./pages/GreenCity/payments/PaymentReimbursement";
import ShowReimbursements from "./pages/GreenCity/payments/ShowReimbursements";
import ShowGroupReimbursements from "./pages/GreenCity/payments/ShowGroupReimbursements";
import PaymentHistory from "./pages/GreenCity/payments/PaymentHistory";
import CreateLeaderEventPost from "./pages/CreateLeaderEventPost";
import ViewPostUser from "./pages/GreenCity/ViewPostUser";
import AddPostUser from "./pages/GreenCity/AddPostUser";
import PaymentInfo from "./pages/GreenCity/PaytoStore/PaymentInfo";
import PaymentReview from "./pages/GreenCity/PaytoStore/PaymentReview";
import RejectReimbursement from "./pages/GreenCity/payments/RejectReimbursement";
import ScanGroupQR from "./pages/GreenCity/JoinProcess/Invite/ScanGroupQR";
import ChatUsers from "./pages/ChatUsers";
import Maintenance from "./pages/Maintenance";

// home page not in use new design////
const HomePage = checkLoggedIn(VotingSeeMorePage);
const CategoryPage = checkLoggedIn(CategoryListPage);
const FacilitatorPage = checkLoggedIn(FacilitatorList);
const SuggestionPage = checkLoggedIn(SuggestionBox);
const CreatePostPage = checkLoggedIn(CreatePost);
const Dashboard = checkLoggedIn(DashboardPage);
const MyFarmPage = checkLoggedIn(MyFarm);
const VotingSeeMore = checkLoggedIn(VotingSeeMorePage);
const PostHistoryScreen = checkLoggedIn(PostHistory);
const EveryOnesPostHistoryScreen = checkLoggedIn(EveryOnesPostHistory);
const CommentHistoryScreen = checkLoggedIn(CommentHistory);
const Search = checkLoggedIn(SearchScreen);
const CreateGroupStep1Screen = checkLoggedIn(CreateGroupStep1);
const CreateGroupStep2Screen = checkLoggedIn(CreateGroupStep2);
const GroupInfoReviewScreen = checkLoggedIn(GroupInfoReview);
const CreateLeaderEventPostScreen = checkLoggedIn(CreateLeaderEventPost);
const DisclosureScreen = checkLoggedIn(Disclosure);
const CreateGroupStepPIIScreen = checkLoggedIn(CreateGroupStepPII);
const GroupOwnerSettingScreen = checkLoggedIn(GroupOwnerSettingPage);
const ViewGroupPostScreen = checkLoggedIn(ViewGroupPost);
const GroupEventSettingScreen = checkLoggedIn(GroupEventSettingPage);
const MemberListScreen = checkLoggedIn(MemberList);
const GroupMembersScreen = checkLoggedIn(GroupMembers);
const ApprovedMemberListScreen = checkLoggedIn(ApprovedMemberList);
const CalenderEventsScreen = checkLoggedIn(CalenderEvents);
const UserChatScreen = checkLoggedIn(UserChat);
const MemberPaymentStatusScreen = checkLoggedIn(MemberPaymentStatus);

const EventApplicationPaymentScreen = checkLoggedIn(EventApplicationPayment);
const GroupPaymentScreen = checkLoggedIn(GroupPayment);
const GroupEventsCalendarScreen = checkLoggedIn(GroupEventsCalendar);
const UserEventCancellationScreen = checkLoggedIn(UserEventCancellation);
const RefundEventFeeScreen = checkLoggedIn(RefundEventFee);
const EventUsersScreen = checkLoggedIn(EventUsers);
const CancelRequestsPageScreen = checkLoggedIn(CancelRequestsPage);
const GroupInviteScreen = checkLoggedIn(GroupInvite);
const GroupRolesScreen = checkLoggedIn(GroupRoles);
const InvitionLinkCreationScreen = checkLoggedIn(InvitionLinkCreations);
const UserChatListScreen = checkLoggedIn(UserChatList);
const ScanStoreQRScreen = checkLoggedIn(ScanStoreQR);
const GroupUserPaymentScreen = checkLoggedIn(GroupUserPayment);

const PaymentReimbursementScreen = checkLoggedIn(PaymentReimbursement);
const EventPostDetailsScreen = checkLoggedIn(EventPostDetails);
const UserEventPaymentDetailScreen = checkLoggedIn(UserEventPaymentDetail);
const EventCancelDetailsScreen = checkLoggedIn(EventCancelDetails);
const ShowReimbursementsScreen = checkLoggedIn(ShowReimbursements);
const ShowGroupReimbursementsScreen = checkLoggedIn(ShowGroupReimbursements);
const RejectReimbursementScreen = checkLoggedIn(RejectReimbursement);
const PaymentHistoryScreen = checkLoggedIn(PaymentHistory);
const ViewPostUserScreen = checkLoggedIn(ViewPostUser);
const AddPostUserScreen = checkLoggedIn(AddPostUser);
const PaymentInfoScreen = checkLoggedIn(PaymentInfo);
const PaymentReviewScreen = checkLoggedIn(PaymentReview);
const ScanGroupQRScreen = checkLoggedIn(ScanGroupQR);
const PostReportScreen = checkLoggedIn(PostReport);
const ChatUsersScreen = checkLoggedIn(ChatUsers);

function App() {
  Config.default = "ja";
  Config.list = language_config;

  const { user } = useSelector((state: any) => state.userAuth);

  useLayoutEffect(() => {
    if (user?.id) {
      setAuthorizationToken(user.auth_token);
    }
  }, [user]);

  const theme = createTheme({
    typography: {
      fontFamily: "mplus-1c-regular",
    },
    palette: {
      primary: {
        main: colors.farm_green500,
        contrastText: "white",
      },
      secondary: {
        main: colors.farm_blue200,
        light: colors.farm_blue200,
        contrastText: "white",
      },
    },
    components: {
      MuiInputLabel: {
        styleOverrides: {
          root: {
            userSelect: "text",
          },
        },
      },
    },
  });

  // アプリ読み込み中に表示していた DOM を削除
  const elm = document.getElementById("app-initial-container");
  if (elm) elm.remove();

  return (
    <AuthProvider>
      <ThemeProvider theme={theme}>
        <Translator>
          <div className="App">
            <Router>
              <header>
                <Header />
              </header>
              <PageViewTracker />
              <Routes>
                { ManagementRoutes }

                <Route path="/" element={<IntroPage />} />
                <Route path="/home" element={<HomePage />} />
                <Route path="/categories" element={<CategoryPage />} />
                <Route path="/facilitator" element={<FacilitatorPage />} />
                <Route path="/suggestion" element={<SuggestionPage />} />
                <Route path="/createPost" element={<CreatePostPage />} />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/myfarm" element={<MyFarmPage />} />
                <Route path="/search" element={<Search />} />
                <Route path="/posthistory" element={<PostHistoryScreen />} />
                <Route path="/votingseemore" element={<VotingSeeMore />} />
                <Route path="/group_chat_list" element={<GroupChatList />} />

                <Route path="/everyoneshistory" element={<EveryOnesPostHistoryScreen />} />
                <Route path="/commenthistory" element={<CommentHistoryScreen />} />
                <Route path="/creategroupstep1" element={<CreateGroupStep1Screen />} />
                <Route path="/creategroupsteptwo" element={<CreateGroupStep2Screen />} />
                <Route path="/groupinforeview" element={<GroupInfoReviewScreen />} />

                <Route path="/disclosure" element={<DisclosureScreen />} />
                <Route path="/steppii" element={<CreateGroupStepPIIScreen />} />
                <Route path="/groupleader" element={<GroupOwnerSettingScreen />} />
                <Route path="/unauthorized" element={<Unauthorized />} />
                <Route path="/viewGroupPost" element={<ViewGroupPostScreen />} />
                <Route path="/groupeventsetting" element={<GroupEventSettingScreen />} />
                <Route path="/userchat" element={<UserChatScreen />} />
                <Route path="/members" element={<GroupMembersScreen />} />
                <Route path="/memberlist" element={<MemberListScreen />} />
                <Route path="/approved_member_list" element={<ApprovedMemberListScreen />} />
                <Route path="/userchatlist" element={<UserChatListScreen />} />
                <Route path="/groupcancelmembership" element={<GroupCancelMembership />} />
                <Route path="/groupclosedetails" element={<GroupCloseDetails />} />
                <Route path="/calenderevent" element={<CalenderEventsScreen />} />
                <Route path="/createleadereventpost" element={<CreateLeaderEventPostScreen />} />

                <Route path="/grouppayment" element={<GroupPaymentScreen />} />
                <Route path="/eventapplicationpayment" element={<EventApplicationPaymentScreen />} />
                <Route path="/groupeventscalendar" element={<GroupEventsCalendarScreen />} />
                <Route path="/usereventcancellation" element={<UserEventCancellationScreen />} />
                <Route path="/refundeventfee" element={<RefundEventFeeScreen />} />

                <Route path="/grouproles" element={<GroupRolesScreen />} />
                <Route path="/cancelrequests" element={<CancelRequestsPageScreen />} />
                <Route path="/invitation" element={<InvitionLinkCreationScreen />} />
                <Route path="/groupinvitation" element={<GroupInviteScreen />} />

                <Route path="/eventusers" element={<EventUsersScreen />} />

                <Route path="/memberPaymentStatus" element={<MemberPaymentStatusScreen />} />
                <Route path="/paytostoreqr" element={<ScanStoreQRScreen />} />
                <Route path="/paytouser" element={<GroupUserPaymentScreen />} />

                <Route path="/paymentreimbursement" element={<PaymentReimbursementScreen />} />
                <Route path="/reimbursements" element={<ShowReimbursementsScreen />} />
                <Route path="/groupreimbursements" element={<ShowGroupReimbursementsScreen />} />
                <Route path="/rejectreimbursement" element={<RejectReimbursementScreen />} />
                <Route path="/paymenthistory" element={<PaymentHistoryScreen />} />

                <Route path="/eventpostdetails" element={<EventPostDetailsScreen />} />
                <Route path="/usereventpaymentdetail" element={<UserEventPaymentDetailScreen />} />

                <Route path="/eventcanceldetails" element={<EventCancelDetailsScreen />} />
                <Route path="/viewpostuser" element={<ViewPostUserScreen />} />
                <Route path="/addpostuser" element={<AddPostUserScreen />} />
                <Route path="/paymentinfo" element={<PaymentInfoScreen />} />
                <Route path="/paymentreview" element={<PaymentReviewScreen />} />
                <Route path="/scangroupqr" element={<ScanGroupQRScreen />} />
                <Route path="/post_report" element={<PostReportScreen />} />
                <Route path="/chat_users" element={<ChatUsersScreen />} />

                <Route path="/maintenance" element={<Maintenance />} />
                <Route path="*" element={<NoPage />} />
              </Routes>
            </Router>
          </div>
        </Translator>
      </ThemeProvider>
    </AuthProvider>
  );
}

const NoPage = () => {
  return <h1>Page not found 404</h1>;
};

export default App;

declare global {
  interface Window {
    gtag: Gtag.Gtag;
  }
}

